import dragScroll from "./timeline.dragScroll";
import navigation from "./timeline.navigation";

export default {
    dragScroll,
    navigation
}